module.exports = __webpack_public_path__ + "static/media/feber.cedfce6c.m4a";